import { createFileRoute } from "@tanstack/react-router";
import { TaskBoard } from "@/features/tasks/task-board";

export const Route = createFileRoute("/_app/_main/tasks")({ component: TaskBoard });
